import './Diagram.component.css'

import DiagramComponent from './DiagramComponent'
import React from 'react'
import { axios } from 'config/axios'
import { connect } from 'react-redux'
import { getSamplesByContainerIdURL } from '../../../api/ispyb'

export class DiagramContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dataFetched: null,
      samplesGroupedByContainerId: null,
    }
  }

  loadData(sampleContainersIdsForSelectedBeamLineLocation) {
    this.setState({
      dataFetched: false,
    })

    const url = getSamplesByContainerIdURL(
      this.props.user,
      this.props.proposalName,
      sampleContainersIdsForSelectedBeamLineLocation.join(',')
    )

    axios.get(url).then(response => {
      const samplesGroupedByContainerId = {}
      sampleContainersIdsForSelectedBeamLineLocation.forEach(containerId => {
        samplesGroupedByContainerId[containerId] = response.data.filter(x => x.Container_containerId === containerId)
      })
      this.setState({
        dataFetched: true,
        samplesGroupedByContainerId: samplesGroupedByContainerId,
      })
    })
  }

  componentDidMount() {
    this.loadData(this.props.sampleContainersIdsForSelectedBeamLineLocation)
  }

  // FIXME bmo 20210210
  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps.sampleContainersIdsForSelectedBeamLineLocation)
  }

  componentWillUnmount() {
    this.setState({
      dataFetched: null,
      samplesGroupedByContainerId: null,
    })
  }

  render() {
    return (
      <div>
        {this.props.selectedShipment &&
          this.state.dataFetched &&
          this.props.sampleContainersIdsForSelectedBeamLineLocation &&
          this.state.samplesGroupedByContainerId && (
            <DiagramComponent
              updateSamplesOfSelectedSampleContainerCallback={selected => {
                this.props.updateSamplesOfSelectedSampleContainerCallback(selected)
              }}
              updateSelectedSampleContainerCallback={selected => {
                this.props.updateSelectedSampleContainerCallback(selected)
              }}
              selectedSampleContainer={this.props.selectedSampleContainer}
              fetchDataCallback={() => {
                this.props.fetchDataCallback()
              }}
              user={this.props.user}
              username={this.props.user.username}
              loading={this.state.loading}
              selectedShipment={this.props.selectedShipment}
              configuration={this.props.configuration}
              beamlineLocation={this.props.beamlineLocation}
              containersInfo={this.props.containersInfo}
              samplesGroupedByContainerId={this.state.samplesGroupedByContainerId}
            />
          )}
      </div>
    )
  }
}

export default connect()(DiagramContainer)

DiagramContainer.propTypes = {}
